const EXCLUDED_DOMAINS = ['launchdarkly.com', 'maps.googleapis.com', 'cdn.cookielaw.org', 'geolocation.onetrust.com']
const DYNATRACE_HEADER_PREFIXES = ['x-dtc', 'x-dynatrace']

const isDynatraceHeader = (name: string) =>
  DYNATRACE_HEADER_PREFIXES.some((prefix) => name.toLowerCase().startsWith(prefix))

const isExcludedUrl = (url: string) => EXCLUDED_DOMAINS.some((domain) => url.includes(domain))

const originalOpen = XMLHttpRequest.prototype.open
const originalSetRequestHeader = XMLHttpRequest.prototype.setRequestHeader

XMLHttpRequest.prototype.open = function (
  method: string,
  url: string | URL,
  async?: boolean,
  username?: string | null,
  password?: string | null,
) {
  ;(this as any)._patchedUrl = typeof url === 'string' ? url : url.toString()
  return originalOpen.apply(this, arguments as any)
}

XMLHttpRequest.prototype.setRequestHeader = function (name: string, value: string) {
  if (isExcludedUrl((this as any)._patchedUrl || '') && isDynatraceHeader(name)) {
    return
  }
  return originalSetRequestHeader.call(this, name, value)
}
